import React from "react";
import {useRecordContext} from 'react-admin';
import LaunchIcon from '@mui/icons-material/Launch';
import {d4UrlRest} from "./Env";

export const D4UrlField = ({source}) => {
    const record = useRecordContext();
    return (<a target="_blank" href={record && record[source]}>
        <LaunchIcon/>
    </a>);
}


export const NodeTitle = ({record}) => {
    const node = useRecordContext();
    if (!node) return null;
    return <span>{node ? `${node['base:objName']} (${node['base:objType']} / ${node['base:objScope']})` : ''}</span>;
};
